const statusManipulation = {
  title1: 'Equipamento inativo',
  title2: 'Equipamento em manutenção',
  title3: 'Equipamento apto para uso',
  title4: 'Equipamento não apto para uso',
  title5: 'Status está sendo consolidado. Recarregue a página em instantes',
  title6: 'Equipamento apto em adequação',
  title7: 'Equipamento sem serviços'
};

export default statusManipulation;
